import { handleResponse, authHeader, authHeaderWithFile } from './request';

async function getCollection(colllectionName, q = null) {
    const requestOptions = {
        method: 'GET',
        headers: authHeader(),
    };
    return fetch(`${process.env.VUE_APP_API_URL}${colllectionName}${q ? '?' + q : ''}`, requestOptions)
        .then(handleResponse)
        .catch(error => {
            console.error('API isteği hatası:', error);
            throw error;
        });
}

async function getCollectionItemWithId(colllectionName, id) {
    const requestOptions = {
        method: 'GET',
        headers: authHeader(),
    };
    return fetch(`${process.env.VUE_APP_API_URL}${colllectionName}/${id}`, requestOptions)
        .then(handleResponse)
}



async function deleteItem(colllectionName, itemId) {
    const requestOptions = {
        method: 'DELETE',
        headers: authHeader(),
    };
    return fetch(`${process.env.VUE_APP_API_URL}${colllectionName}/${itemId}`, requestOptions)
        .then(handleResponse)
}


async function postWidthAuth(colllectionName, payload) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify(payload)
    };
    return fetch(`${process.env.VUE_APP_API_URL}${colllectionName}`, requestOptions)
        .then(handleResponse)
}


async function updateCollectionItem(colllectionName, id, payload) {
    const requestOptions = {
        method: 'PUT',
        headers: authHeader(),
        body: JSON.stringify(payload)
    };
    return fetch(`${process.env.VUE_APP_API_URL}${colllectionName}/${id}`, requestOptions)
        .then(handleResponse)
}


async function uploadReport(formData) {

    const requestOptions = {
        method: 'POST',
        body: formData,
        headers: authHeaderWithFile()
    };

    return fetch(`${process.env.VUE_APP_API_URL}report`, requestOptions)
        .then(handleResponse)
}

export default {
    getCollection,
    postWidthAuth,
    deleteItem,
    getCollectionItemWithId,
    updateCollectionItem,
    uploadReport
};